import { useIsHealthdirectSidebarCollapseKilled } from '@/features/flags';
import { useSidebarState } from '@/hooks/usePageShellState';
import { externalLaunchContextAtom } from '@heidi/integrations/ehr/data/atoms';
import { EHRProvider } from '@heidi/schema/ml-scribe';
import { useAtomValue } from 'jotai';
import { useEffect } from 'react';

/**
 * Forces the nav sidebar collapsed on every HealthDirect launch.
 *
 * The HD iframe is space-constrained, so the localStorage-persisted expanded
 * preference must not win on open. The collapse fires once per mount (deps are
 * stable), so a user who expands mid-session is not fought on re-render.
 *
 * Gated behind the `op-scribe-disable-healthdirect-sidebar-collapse` kill
 * switch so the override can be disabled remotely without a redeploy — flip ON
 * to restore the persisted preference for HD launches if this regresses.
 */
export const useCollapseSidebarOnHealthDirectLaunch = () => {
  const { setIsExpanded } = useSidebarState();
  const isCollapseKilled = useIsHealthdirectSidebarCollapseKilled();
  const isHealthDirectLaunch =
    useAtomValue(externalLaunchContextAtom)?.ehrProvider === EHRProvider.Healthdirect;

  useEffect(() => {
    if (isHealthDirectLaunch && !isCollapseKilled) {
      setIsExpanded(false);
    }
  }, [isHealthDirectLaunch, isCollapseKilled, setIsExpanded]);
};
